var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleExclamation = function SvgCircleExclamation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type=circle-exclamation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 14.5002C11.4475 14.5002 10.9998 14.0525 10.9998 13.5002L10.9998 7.00024C10.9998 6.44796 11.4475 6.00024 11.9998 6.00024C12.552 6.00024 12.9998 6.44796 12.9998 7.00024L12.9998 13.5002C12.9998 14.0525 12.552 14.5002 11.9998 14.5002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9998 12.0002C22.9998 18.0754 18.0749 23.0002 11.9998 23.0002C5.92462 23.0002 0.999756 18.0754 0.999757 12.0002C0.999757 5.92511 5.92463 1.00024 11.9998 1.00024C18.0749 1.00024 22.9998 5.92511 22.9998 12.0002ZM11.9998 21.0002C16.9703 21.0002 20.9998 16.9708 20.9998 12.0002C20.9998 7.02968 16.9703 3.00024 11.9998 3.00024C7.02919 3.00024 2.99976 7.02968 2.99976 12.0002C2.99976 16.9708 7.02919 21.0002 11.9998 21.0002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 16.0002C11.4475 16.0002 10.9998 16.448 10.9998 17.0002C10.9998 17.5525 11.4475 18.0002 11.9998 18.0002C12.552 18.0002 12.9998 17.5525 12.9998 17.0002C12.9998 16.448 12.552 16.0002 11.9998 16.0002Z",
    fill: "currentColor"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleExclamation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-exclamation.e737b15a94612f35e188f2f5d51fdc83.svg";